module.exports = __webpack_public_path__ + "img/logoFunEats.82d08d5e.svg";